export default "__VITE_ASSET__CNfXqfFm__"